import makeBox from "./box"

const Box = makeBox("div")

export default Box
